/**
 * The switch for the new inbox (docs/new-inbox-and-deal-flow.md).
 *
 * REACT_APP_NEW_INBOX=on (the same variable the server reads) shows the new
 * inbox at /inbox and /inbox/deal/:id, sends the old /order/:id and /sale/:id
 * links there, and starts deals in Parnexus's own store instead of Sharetribe.
 * Off: everything works as before.
 */
export const newInboxEnabled = () => process.env.REACT_APP_NEW_INBOX === 'on';
